/* eslint-disable import/no-anonymous-default-export */
export default {
  API_ENDPOINT: 'https://calm-bayou-27862.herokuapp.com/api',
  TOKEN_KEY: 'forgetmenot-client-auth-token',
}